import { colorsPalettes, type StrictColor } from "@similarweb/styles";
import { Badge } from "@similarweb/ui-components";

import { StyledCadenceFunctionBadgeIcon } from "./styles";

type CadenceFunctionBadgeVariant = {
    bgColor: StrictColor;
    color: StrictColor;
    showArrow: boolean;
    rotateArrow: boolean;
};

const getCadenceFunctionBadgeVariant = (cadenceFunction: string): CadenceFunctionBadgeVariant => {
    const normalizedFunction = cadenceFunction.toLowerCase();

    if (normalizedFunction === "outbound") {
        return {
            bgColor: colorsPalettes.blue["100"],
            color: colorsPalettes.blue["400"],
            showArrow: true,
            rotateArrow: false,
        };
    }

    if (normalizedFunction === "inbound") {
        return {
            bgColor: colorsPalettes.green["100"],
            color: colorsPalettes.green["500"],
            showArrow: true,
            rotateArrow: true,
        };
    }

    return {
        bgColor: colorsPalettes.carbon["50"],
        color: colorsPalettes.carbon["400"],
        showArrow: false,
        rotateArrow: false,
    };
};

type CadenceFunctionBadgeProps = {
    cadenceFunction: string;
};

export const CadenceFunctionBadge = ({ cadenceFunction }: CadenceFunctionBadgeProps) => {
    const badgeVariant = getCadenceFunctionBadgeVariant(cadenceFunction);

    return (
        <Badge
            bgColor={badgeVariant.bgColor}
            color={badgeVariant.color}
            type="custom"
        >
            {badgeVariant.showArrow ? (
                <StyledCadenceFunctionBadgeIcon $isRotated={badgeVariant.rotateArrow}>
                    <Badge.Icon
                        iconName="arrow-slant-right"
                        iconColor={badgeVariant.color}
                    />
                </StyledCadenceFunctionBadgeIcon>
            ) : null}
            {cadenceFunction}
        </Badge>
    );
};
